#import "./PolicyAdminFields.graphql"

query GetPolicyRegister {
  policies {
    ...PolicyAdminFields
    summary
  }
  trainingComplianceSummary {
    peopleYetToAcknowledge
  }
}
